// src/styles/GlobalStyles.ts
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --font-sans: "Figtree", system-ui, -apple-system, BlinkMacSystemFont,
                 "Segoe UI", Helvetica, Arial, sans-serif;
    --font-serif: "Playfair Display", Georgia, "Times New Roman", serif;
    --font-hand: "Gochi Hand", "Figtree", system-ui, sans-serif;
    --font-future: "Michroma", "Figtree", system-ui, sans-serif;
    --font-tech: "Silkscreen", "Figtree", system-ui, sans-serif;
    --scrollbar-track: rgba(255,255,255,.05);
    --scrollbar-track-subtle: rgba(255,255,255,.04);
    --scrollbar-thumb-start: rgba(224,161,94,.58);
    --scrollbar-thumb-end: rgba(224,161,94,.34);
    --scrollbar-thumb-start-hover: rgba(224,161,94,.72);
    --scrollbar-thumb-end-hover: rgba(224,161,94,.46);
    --scrollbar-border: rgba(17,20,27,.92);
    --select-menu-bg: #171c24;
    --select-menu-bg-strong: #1d2430;
    --select-menu-text: rgba(248,250,255,.96);
    --select-menu-text-muted: rgba(232,234,237,.64);
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: var(--font-sans);
    font-weight: 400;                  /* variable-font axis default */
    background: ${({ theme }) => theme.colors.gray100};
    color: ${({ theme }) => theme.colors.gray700};
    -webkit-font-smoothing: antialiased;
  }

  select {
    color-scheme: dark;
    font-family: var(--font-sans);
  }

  option,
  optgroup {
    background: var(--select-menu-bg);
    color: var(--select-menu-text);
    font-family: var(--font-sans);
  }

  option:checked,
  option:focus,
  option:hover {
    background: var(--select-menu-bg-strong);
    color: var(--select-menu-text);
  }

  option:disabled,
  optgroup:disabled {
    color: var(--select-menu-text-muted);
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-thumb-start) var(--scrollbar-track);
  }

  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  *::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
    border-radius: 999px;
  }

  *::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, var(--scrollbar-thumb-start), var(--scrollbar-thumb-end));
    border-radius: 999px;
    border: 2px solid var(--scrollbar-border);
  }

  *::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, var(--scrollbar-thumb-start-hover), var(--scrollbar-thumb-end-hover));
  }

  *::-webkit-scrollbar-corner {
    background: transparent;
  }

  em, i {
    font-family: var(--font-serif);
    font-style: italic;
    font-weight: 600;
  }
`;
